export enum WrapupPrompt {
  Optional = 'optional',
  Mandatory = 'mandatory',
  Timeout = 'timeout',
  ForcedTimeout = 'forcedTimeout',
  AgentRequested = 'agentRequested'
}
